// 云图下发的POI点信息存在 _ 开头字段
/* eslint-disable no-underscore-dangle */

// 工具
import {
  native, webviewInfo, util, log
} from '@ali/amap-lib';
import $ from '../../../common/js/zepto';
import meIcon from '../../../assets/map/icon.png';
import poiIcon from '../../../assets/map/poi.png';

export default class Map {
  constructor(dom, poiData) {
    this.dom = dom;
    this.poiData = poiData;
    // this.poiData = {
    //   id: 0,
    //   type: 0, // 0：单点标注  1：多点标注
    //   poi: {
    //     tableId: '5d26eeb7305a2a709715f69a',
    //     name: '湖州市中心血站',
    //     poiId: 'B056F003KQ',
    //     lng: 112.581963,
    //     lat: 35.06615,
    //   }
    // };

    this.map = null; // 地图
    this.search = null; // 搜索控件
    this.labelLayer = null;
    this.myPosiMarker = []; // 我的位置点标注
    this.singleMarker = []; // 单点标注
    this.multiMarkers = []; // 多点标注
    this.location = { // 我的定位相关信息
      lon: 116.397474,
      lat: 39.90923,
      adcode: '110000',
      cityName: '北京市'
    };

    this.myLocation();
  }

  // 获取我的位置信息
  myLocation() {
    if (webviewInfo.isInAmap()) {
      native.getMapLocation((res) => {
        if (res) {
          this.location.lon = res.lon || 116.397474;
          this.location.lat = res.lat || 39.90923;
          this.location.adcode = res.adcode || '110000';
          this.location.cityName = res.cityName || '北京市';
          this.createMap();
        }
      });
    } else {
      this.createMap();
    }
  }

  // 创建地图
  createMap() {
    const self = this;
    this.map = new AMap.Map(this.dom, {
      // zoom: 10,
      center: [self.location.lon, self.location.lat],
      dragEnable: true,
      resizeEnable: true,
      doubleClickZoom: false,
    });
    // 我的位置
    if (webviewInfo.isInAmap()) {
      const marker = new AMap.Marker({
        map: this.map,
        position: [this.location.lon, this.location.lat],
        offset: new AMap.Pixel(-20, -23),
        icon: new AMap.Icon({
          size: new AMap.Size(40, 47),
          imageSize: new AMap.Size(40, 47),
          image: meIcon
        })
      });
      this.myPosiMarker.push(marker);
    }
    // 创建文案标注图层
    this.labelLayer = new AMap.LabelsLayer({
      rejectMapMask: true,
      collision: true,
      animation: true,
      zIndex: 100,
    });
    this.map.add(this.labelLayer);
    // 渲染单点或多点地图
    this.createPoi();
    // 去掉地图下方的版权等info
    $('.amap-logo').css('display', 'none!important');
    $('.amap-copyright').css('display', 'none!important');
  }

  // 创建点标注
  createPoi() {
    const { type } = this.poiData;
    if (+type === 1) {
      this.getCloundData();
    } else {
      this.createSingleMarker();
    }
  }

  // 创建单个点
  createSingleMarker() {
    const {
      poiId, name, lng, lat
    } = this.poiData.poi;
    const marker = new AMap.Marker({
      title: name,
      map: this.map,
      position: new AMap.LngLat(lng, lat),
      offset: new AMap.Pixel(-15, -17),
      icon: new AMap.Icon({
        size: new AMap.Size(30, 34),
        imageSize: new AMap.Size(30, 34),
        image: poiIcon
      }),
      clickable: true,
      raiseOnDrag: true
    });
    // 添加右侧文案标注
    if (name) {
      const poiData = {
        _name: name,
        _location: {
          lng,
          lat
        }
      };
      this.setLabelMarker(poiData);
    }
    marker.on('click', () => {
      const id = util.getUrlParam('id');
      log.log('poi', { type: id, poiId });
      if (webviewInfo.isInAmap()) {
        native.openPoi({
          poiid: poiId,
          lon: lng,
          lat,
          name,
        }, 1);
      } else {
        const schema = `amapuri://poi/detail?poiid=${poiId}&lat=${lat}&lon=${lng}&poiname=${name}&dev=&external=&zoomlevel=&ranklistmore=&sourceApplication=htc`;
        window.location.href = `https://m.autonavi.com/callnative/?schema=${encodeURIComponent(
          schema
        )}&title=%E9%AB%98%E5%BE%B7%E5%9C%B0%E5%9B%BE`;
      }
    });
    this.singleMarker.push(marker);
    // 将单点置于视野内
    this.map.setFitView(this.singleMarker);
    this.map.setZoom(12);
  }

  // 获取云图数据
  getCloundData() {
    const { tableId } = this.poiData.poi;
    const options = {
      pageSize: 100
    };
    this.map.plugin(['AMap.CloudDataSearch'], () => {
      if (!this.search) {
        this.search = new AMap.CloudDataSearch(tableId, options);
      }
      this.search.searchByDistrict('全国', (status, result) => {
        // 清空icon点标注
        this.map.remove(this.multiMarkers);
        this.multiMarkers = [];
        // 处理数据
        if (status === 'complete' && result.info === 'OK') {
          this.showPoiData(result.datas);
        } else if (status === 'no_data') {
          console.log('没有搜索到数据');
        } else if (status === 'error') {
          console.log('加载异常，请检查网络');
        }
      });
    });
  }

  // 渲染云图数据
  showPoiData(poiData) {
    poiData.forEach((poi) => {
      const markerPoi = new AMap.Marker({
        title: poi._name,
        map: this.map,
        position: new AMap.LngLat(poi._location.lng, poi._location.lat),
        offset: new AMap.Pixel(-15, -17),
        icon: new AMap.Icon({
          size: new AMap.Size(30, 34),
          imageSize: new AMap.Size(30, 34),
          image: poiIcon
        }),
        clickable: true,
        raiseOnDrag: true
      });
      // 添加右侧文案标注
      this.setLabelMarker(poi);
      markerPoi.on('click', () => {
        const id = util.getUrlParam('id');
        log.log('poi', { type: id, poiId: poi.POIID });
        if (webviewInfo.isInAmap()) {
          native.openPoi({
            poiid: poi.POIID,
            lon: poi._location.lng,
            lat: poi._location.lat,
            name: poi._name,
          }, 1);
        } else {
          const schema = `amapuri://poi/detail?poiid=${poi.POIID}&lat=${poi._location.lat}&lon=${poi._location.lng}&poiname=${poi._name}&dev=&external=&zoomlevel=&ranklistmore=&sourceApplication=htc`;
          window.location.href = `https://m.autonavi.com/callnative/?schema=${encodeURIComponent(
            schema
          )}&title=%E9%AB%98%E5%BE%B7%E5%9C%B0%E5%9B%BE`;
        }
      });
      this.multiMarkers.push(markerPoi);
    });
    // 将所有点置于视野内
    this.map.setFitView(this.multiMarkers);
  }

  // 添加右侧文案标注
  setLabelMarker(poi) {
    const style = {
      name: poi._name,
      position: [poi._location.lng, poi._location.lat],
      zooms: [3, 18],
      opacity: 1,
      text: {
        content: poi._name,
        direction: 'right',
        offset: [14, -2],
        style: {
          fontSize: 12,
          fillColor: '#000',
        }
      }
    };
    const labelsMarker = new AMap.LabelMarker(style);
    this.labelLayer.add(labelsMarker);
  }
}
